import { render } from "./announcementSms.vue?vue&type=template&id=4026078d&scoped=true"
import script from "./announcementSms.vue?vue&type=script&lang=js"
export * from "./announcementSms.vue?vue&type=script&lang=js"

import "./announcementSms.vue?vue&type=style&index=0&id=4026078d&scoped=true&lang=css"

import exportComponent from "/mnt/extra-storage/gafwa_frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4026078d"]])

export default __exports__